module.exports = __webpack_public_path__ + "img/586.a1ec33c4.jpg";